import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryGoToTopButton({scrollToTop}) {
    // Used in GlossaryContent to display go to top of the screen button

    // BUILD
    if (isNullOrUndefined(scrollToTop))
        return null
    return (
        <button className={"fixed bottom-[16px] right-[24px] bg-greenStar bg-opacity-100 hover:bg-opacity-80 flex justify-center items-center text-black px-[4px] py-[4px] rounded-full transition"}
                onClick={scrollToTop}
                aria-label="Revenir en haut">
            <i className="material-icons text-[24px]">
                arrow_circle_up
            </i>
        </button>
    );
}